<template>
<div>
    <v-snackbar v-model="transFail" :timeout="4000" top color="red">
      <span>An error occurred! Please Try Again Later</span> 
      <v-btn text color="white" @click="transFail = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarContinueTransSuccess" :timeout="4000" top color="success">
      <span>Success! Your Transaction Will Be Verified!</span> 
      <v-btn text color="white" @click="snackbarContinueTransSuccess = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarContinueTransError" :timeout="7000" top color="red">
      <span>Not Successful !!!, Try Agin Later</span> 
      <v-btn text color="white" @click="snackbarContinueTransError = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="loadingProgress" persistent overlay-color="black" style="height:100vh">
        <!-- <v-card flat transparent> -->
            <v-card-text class="text-center">
                <v-progress-circular indeterminate :size="70" :width="7" color="#08911B"></v-progress-circular>
            </v-card-text>
        <!-- </v-card> -->
        
        <!-- <v-container fill-height>
            <v-layout justify-center align-center>
            <v-progress-circular indeterminate :size="70" :width="7" color="#08911B"></v-progress-circular>
            </v-layout>
        </v-container> -->
    </v-dialog>
    
    <v-dialog v-model="paydialog" width="100%" persistent>
        <!-- for connecting to web payment services -->

        <v-card height="500">
            <v-app-bar fixed dense>
                <v-btn @click="paydialog=false" color="#08911B" dark class="ma-4">CLOSE</v-btn>
            </v-app-bar>
            <iframe style="width:100%; height:100% " :src="src">
            </iframe>
        </v-card>

        <!-- Implementing Astra Pay on Insurance App -->

         <!-- <v-card height="500">
            <v-app-bar fixed dense>
                <v-btn @click="paydialog=false" color="#08911B" dark class="ma-4">CLOSE</v-btn>
            </v-app-bar>
            <iframe style="width:100%; height:100% " src="../components/AstraLogin">
            </iframe>
        </v-card>  -->
        
    </v-dialog>
    <v-dialog v-model="counterPaydialog" width="60%" persistent>
        <v-stepper v-model="stepper" vertical>
            <v-stepper-step :complete="stepper > 1" step="1" color="#62AE32">
                Transaction Details
                <br>
                <small class="black--text font-weight-bold">Use Your preferred method of payment, click 'I HAVE MADE THIS PAYMENT' to continue</small>
            </v-stepper-step>

            <v-stepper-content step="1">
                <v-card flat>
                    <v-card-title class="mt-n6">
                        <span class=" black--text">Bank Transactions</span>
                    </v-card-title>
                    <v-card-text>
                        <v-card-text class="black--text">BANK NAME: ASTRA POLARIS BANK</v-card-text>
                        <v-card-text class="black--text">ACCONT NAME: PEER COVER INC</v-card-text>
                        <v-card-text class="black--text">ACCOUNT NUMBER: 2056750533</v-card-text>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="counterPayDialogFalse()" color="#62AE32">Cancel</v-btn>
                        <v-btn color="#62AE32" @click="haveMadeThisPayment()" dark>I HAVE MADE THIS PAYMENT</v-btn>
                    </v-card-actions>
                    </v-card>
                
            </v-stepper-content>
            <!-- STEP 2 -->
            <v-stepper-step :complete="stepper > 2" step="2" color="#62AE32">
                Enter Unique Identifier
                <small class="black--text font-weight-bold">Please Enter The Reference Number For The Transaction You Carried Out And Select The Platform You Paid With</small>
            </v-stepper-step>
            <v-stepper-content step="2">
                <v-card>
                    <v-container>
                        <v-form ref="form">
                            <v-row class="" no-gutters>
                                <v-col cols="12" lg="6" md="6" sm="6">Transaction Id</v-col>
                                <v-col cols="12" lg="6" md="6" sm="6">
                                    <v-text-field outlined readonly  color="#62AE32" v-model="transactionCounterId" dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="" no-gutters>
                                <v-col cols="12" lg="6" md="6" sm="6">Payment Method</v-col>
                                <v-col cols="12" lg="6" md="6" sm="6">
                                    <v-select outlined :items="paymentMethods" label="select policy type..."  color="#62AE32" v-model="paymentMethod" dense  @change="payMethodChanged($event)" :rules="methodRules" required></v-select>
                                </v-col>
                            </v-row>
                            <v-row class="" no-gutters>
                                <v-col cols="12" lg="6" md="6" sm="6">Transaction Reference Number <v-subheader class="mt-n5">(unique identifier)</v-subheader></v-col>
                                <v-col cols="12" lg="6" md="6" sm="6">
                                    <v-text-field  outlined label="" color="#62AE32" name="transRef" v-model="transRef" type="text" dense :rules="refRules" required></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                        
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text @click="counterPayDialogFalse()" color="#62AE32">Cancel</v-btn>
                            <v-btn dark color="#62AE32" @click="continueOverTheCounterTrans()" :loading="loadingConfirm">SUMBIT</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
                </v-stepper-content>
        </v-stepper>
    </v-dialog>
    <v-snackbar v-model="snackbar"  :timeout="4000" top :color="snackcolor">
        <span>{{snackbarMsg}}</span> 
        <v-btn text color="white" @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-container>
        <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
        <v-toolbar flat color="#F0FFEA" height="50" >
            <v-toolbar-title style="color:#62AE32" class="headline">Claim</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu
                transition="slide-x-transition"
                bottom
                right
                :close-on-content-click="false"
                >
                <template v-slot:activator="{ on }">
                    <v-btn
                    class=""
                    color="#62AE32"
                    dark
                    v-on="on"
                    >
                   CLAIM ACTIONS
                    </v-btn>
                </template>

                <v-list dense nav>
                    <v-list-item @click="canDecline()">
                    <v-list-item-icon>
                        <v-icon color="#B45C5C">mdi-thumb-down</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title color="#08911B">Decline</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="canRecommend()">
                    <v-list-item-icon>
                        <v-icon color="#B45C5C">mdi-handball</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Recommend Claim Amount</v-list-item-title>
                    </v-list-item>
                    <v-menu
                        transition="slide-x-transition"
                        bottom
                        right
                        >
                        <template v-slot:activator="{ on }">
                            <v-list-item v-on="on">
                                <v-list-item-icon>
                                    <v-icon color="#B45C5C">mdi-currency-ngn</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Make Payment</v-list-item-title>
                            </v-list-item>
                            
                        </template>

                        <v-list dense nav>
                            <v-list-item @click="canMakePay()">
                            <v-list-item-icon>
                                <v-icon color="blue">mdi-alpha-a</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title color="#08911B">Pay with Astra</v-list-item-title>
                            </v-list-item>
                           
                        </v-list>
                        <v-list dense nav>
                            <v-list-item >
                            <v-list-item-icon>
                                <v-icon color="blue">mdi-alpha-a</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title color="#08911B" ><v-btn text class="text-none pa-0">Pay with Card</v-btn></v-list-item-title>
                            </v-list-item>
                           
                        </v-list>
                        <v-list dense nav>
                            <v-list-item @click="counterPay()">
                            <v-list-item-icon>
                                <v-icon color="#B45C5C">mdi-bank-transfer-in</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title color="#08911B">Pay Over The Counter</v-list-item-title>
                            </v-list-item>
                           
                        </v-list>
                    </v-menu>
                   
                </v-list>
            </v-menu>

        </v-toolbar>    
          <v-dialog persistent v-model="dialog2" max-width="300px">
            <v-card>
            <v-card-title>
            <span class=" black--text">Decline Claim</span>
            </v-card-title>

            <v-card-text>
            <v-container>
                <v-card-text class="red--text">You are about to decline a claim. No action will be carried on this claim after decline</v-card-text>
                                    
            </v-container>
            </v-card-text>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#62AE32" text @click="dialog2=false">CANCEL</v-btn>
            <v-btn color="#62AE32" text @click="decline()" :loading="loading">DECLINE</v-btn>
            
            </v-card-actions>
        </v-card>
    </v-dialog>
        <div class="mt-7">
            <v-row>
                <v-col cols="12" md="8" sm="12">
                    <v-card class="ml-4" color="#F0FFEA" max-width="400" flat> 
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Name</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    label=""
                                    readonly
                                    solo
                                    flat
                                    dense
                                    v-model="claim.name"
                                    style="font-size:14px, width:100%"
                                    class="black--text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Username</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    label=""
                                    readonly
                                    solo
                                    flat
                                    dense
                                    v-model="claim.policy_holder"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                                <span style="font-size:13px; color:#615D5D">Community</span>
                                
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    readonly
                                    label=""
                                    solo
                                    flat
                                    dense
                                    v-model="claim.community_name"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6">
                                <span style="font-size:13px; color:#615D5D">Package</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">          
                                <v-textarea v-model="insPackage" readonly solo flat auto-grow="true" label="" style="font-size:14px"
                        class="black--text"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                                <span style="font-size:13px; color:#615D5D">Policy Number</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    readonly
                                    label=""
                                    solo
                                    flat
                                    dense
                                    v-model="claim.policy_number"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                                
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                                <span style="font-size:13px; color:#615D5D">Incident Report</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">

                            <v-textarea v-model="claim.incident_report" readonly solo flat auto-grow="true" label="" style="font-size:14px"
                            class="black--text"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                                <span style="font-size:13px; color:#615D5D">Incident Cause</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    readonly
                                    label=""
                                    solo
                                    flat
                                    dense
                                    v-model="claim.incident_cause"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <!-- Incident Location Graph-->
                        <v-row>
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                                <span style="font-size:13px; color:#615D5D">Incident Location</span>
                            </v-col>
                            <v-col cols='12' md='8' sm='6'>
                                <gmap-map
                                    :center="center"
                                    :zoom="12"
                                    style="width:100%;  height: 200px;"
                                ></gmap-map>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                                <span style="font-size:13px; color:#615D5D">Claim Owner Amount</span>                  
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    readonly
                                    label=""
                                    solo
                                    flat
                                    dense
                                    v-model="claim.policy_holder_claim_amount"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                                <span style="font-size:13px; color:#615D5D">Loss Assessor's Amount</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    readonly
                                    label=""
                                    solo
                                    flat
                                    dense
                                    v-model="claim.loss_assessor_claim_amount"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                                <span style="font-size:13px; color:#615D5D">Recommendation Rejection Message</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">

                            <v-textarea v-model="claim.rejection_message" readonly solo flat auto-grow="true" label="" style="font-size:14px"
                            class="black--text"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                                <span style="font-size:13px; color:#615D5D">Consultant Amount</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    readonly
                                    label=""
                                    solo
                                    flat
                                    dense
                                    v-model="claim.consultant_claim_amount"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Claim Status</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    label=""
                                    readonly
                                    solo
                                    flat
                                    dense
                                    v-model="claim.status"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                           <v-row no-gutters class="mb-n2">
                            <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Final Claim Amount Paid</span>
                            </v-col>
                            <v-col cols="12" md="8" sm="6">
                                <v-text-field
                                    label=""
                                    readonly
                                    solo
                                    flat
                                    dense
                                    v-model="claim.claim_amount_paid"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <!-- Images -->
                         <v-dialog v-model="dialog1" max-width="85vw" >
                            <img :src="src" alt="" width="100%" @click.stop="dialog1=false">
                        </v-dialog>
                        <v-row>
                            <v-col cols="12" sm="12" >
                            <v-card>
                                <v-card-title>
                                    <span style="font-size:14px; color:#615D5D">Claim Images</span>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-container fluid>
                                <v-row>
                                    <v-col
                                    v-for="img in claimImages"
                                    :key="img.url"
                                    class="d-flex child-flex"
                                    cols="4"
                                    >
                                    <v-card flat tile class="d-flex">
                                        <v-img
                                        :src="getImgUrl(img.imgUrl)"
                                        :lazy-src="img.url"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                        @click="zoom(img.imgUrl)"
                                        style="cursor:pointer"
                                        >
                                        </v-img>
                                    </v-card>
                                    </v-col>
                                </v-row>
                                 <v-row>
                                    <v-col
                                    class="d-flex child-flex"
                                    cols="4"
                                    >
                                    <v-card flat tile class="d-flex">
                                        <v-img
                                        :src="getImgUrl(this.$store.state.community.viewclaims[0].claim_holder_quotationdoc_url)"
                                        :lazy-src="this.$store.state.community.viewclaims[0].claim_holder_quotationdoc_url"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                        @click="zoom(quodoc2)"
                                        style="cursor:pointer"
                                        >
                                        </v-img>
                                        <!-- <v-card-text>Claim Owner Quotation Doc</v-card-text> -->
                                    </v-card>
                                    <!-- <v-subheader>Claim Owner Quotation Doc</v-subheader> -->
                                    </v-col>
                                    <v-col
                                    class="d-flex child-flex"
                                    cols="4"
                                    >
                                    <v-card flat tile class="d-flex">
                                        <v-img
                                        :src="getImgUrl(this.$store.state.community.viewclaims[0].loss_assessor_quotationdoc_url)"
                                        :lazy-src="this.$store.state.community.viewclaims[0].loss_assessor_quotationdoc_url"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                        @click="zoom(quodoc1)"
                                        style="cursor:pointer"
                                        >
                                        </v-img>
                                        <!-- <v-card-text>Loss Assessor Quotation Doc</v-card-text> -->
                                    </v-card>
                                    <!-- <v-subheader>Loss Assessor Quotation Doc</v-subheader> -->
                                    </v-col>
                                </v-row>
                                <!-- <v-row>
                                    <v-card-text style="font-size:14px; color:#615D5D" class="mx-5 mb-n5">Claim Documents</v-card-text>
                                   
                                    <v-col v-for="file in files" :key="file.url">
                                        <v-card-text>
                                            
                                            <v-btn dark color="#B45C5C" @click="downloadWithAxios(file.url)"><span>{{file.text}}</span>
                                                <v-icon right>mdi-arrow-down</v-icon>
                                            </v-btn>
                                        </v-card-text>
                                    </v-col>
                                </v-row> -->
                                </v-container>
                            </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                    <!-- <v-card class="ml-4" color="#F0FFEA" max-width="400" flat>  -->
                    <v-card
                        max-width="400"
                        class="ml-4"
                    >
                        <v-card
                        dark
                        flat
                        >
                        
                        <v-card-title class="pa-2" >
                            
                            <v-icon>mdi-human-greeting</v-icon>
                           
                            <h3 class="title font-weight-light text-center grow">Claim Timeline</h3>
                            <v-avatar size="30px">
                            <v-img :src="getImgUrl(this.$store.state.claims.userclaimdetails[0].profile_img_url)" lazy-src='/profile_pic.svg'></v-img>
                            </v-avatar>
                        </v-card-title>
                        </v-card>
                        <v-card-text class="py-0">
                        <v-timeline
                            align-top
                            dense
                        >
                            <v-timeline-item
                            color="#B45C5C"
                            small
                            v-for="time in claimTimeline" :key="time.id"
                            >
                            <v-row class="pt-1" >
                                <v-col>
                                <strong>{{time.status}}</strong>
                                
                                <div class="caption">By: {{time.actor_username}}</div>
                                <div class="caption">{{time.date}}</div>
                                </v-col>
                            </v-row>
                            </v-timeline-item>   
                        </v-timeline>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            
            <v-row>
                <v-col cols="12" md="8" sm="6">
                    <v-dialog persistent v-model="dialog" max-width="300px">
                        <v-card>
                            <v-card-title>
                            <span class=" black--text">Recommend Price</span>
                            </v-card-title>

                            <v-card-text>
                            <v-container>
                                <v-text-field
                                    color="#62AE32"
                                    label="price"
                                    type="number"
                                    outlined
                                    flat
                                    dense
                                    v-model="price"
                                    style="font-size:14px"
                                    class="black--text"
                                ></v-text-field>
                                                    
                            </v-container>
                            </v-card-text>

                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#62AE32" text @click="dialog=false">CANCEL</v-btn>
                            <v-btn color="#62AE32" :loading="loading" text @click="recommend()">RECOMMEND</v-btn>
                            
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
        </div>
        
    </div>
    </v-container>

</div>
   
</template>
<script>
    import AstraLogin from '../components/AstraLogin';
    import axios from 'axios'

    export default {
        name: 'communityMembers',
        components: {
            AstraLogin,
        },

        data: () => ({
            // quodoc1:this.$store.state.community.viewclaims[0].loss_assessor_quotationdoc_url,
            // quodoc2:this.$store.state.community.viewclaims[0].claim_holder_quotationdoc_url,
            insPackage:"Vehicle Insurance for Accidental Damages Including Theft",
            transactionCounterId:0,
            dialog:false,
            dialog1:false,
            dialog2:false,
            counterPaydialog:false,
            loading:false,
            snackbar:false,
            snackbarMsg:'',
            price:'',
            snackcolor:'success',
            paydialog:false,
            // url:"https://cover-my-car.herokuapp.com",
            url:"https://res.cloudinary.com/dmnghlyic/image/upload/v1587634815/",
            refNum:'',
            amount:0,
            src:'',
            // center: { lat: 7.3581351, lng: 3.8045906 },
            center: null,
            transFail:false,
            loadingProgress:false,
            stepper:1,
            paymentMethods:['USSD', 'BANK TRANSFER', 'OVER THE COUNTER', 'OTHERS'],
            paymentMethod:'',
            loadingConfirm:false,
            transRef:'',
            snackbarContinueTransSuccess:false,          
            snackbarContinueTransError:false,
            refRules:[v => !!v || 'Transaction Reference is required'],          
            methodRules:[v => !!v || 'Payment Method is required'],          
        }),
        computed:{
            quodoc1(){
                return this.$store.state.community.viewclaims[0].loss_assessor_quotationdoc_url
            },
            quodoc2(){
                return this.$store.state.community.viewclaims[0].claim_holder_quotationdoc_url
            },
            claim(){
                let getClaim= this.$store.state.community.viewclaims[0]
                if (getClaim.consultant_claim_amount==="" || getClaim.consultant_claim_amount===null){
                    getClaim.consultant_claim_amount='0.00'
                } 
                if (getClaim.incident_report==="" || getClaim.incident_report===null){
                    getClaim.incident_report='None'
                }
                if (getClaim.loss_assessor_claim_amount=="" || getClaim.loss_assessor_claim_amount===null){
                    getClaim.loss_assessor_claim_amount='0.00'
                }
                if (getClaim.rejection_message==="" || getClaim.rejection_message===null){
                    getClaim.rejection_message='None'
                }
                if (getClaim.claim_amount_paid==="" || getClaim.claimamount__paid===null){
                    getClaim.claim_amount_paid='0.00'
                }
                getClaim.policy_holder_claim_amount = getClaim.policy_holder_claim_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                getClaim.consultant_claim_amount = getClaim.consultant_claim_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                getClaim.loss_assessor_claim_amount = getClaim.loss_assessor_claim_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                getClaim.claim_amount_paid = getClaim.claim_amount_paid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                return getClaim
            },
            claimTimeline(){
                 let trans = this.$store.state.community.viewclaims[0].claimtimeline
                 for(let j=0; j<trans.length; j++){
                    trans[j].date= trans[j].date.slice(0, 19).replace('T', ' ');
                }
                return trans
            },
            claimImages(){
                return this.$store.state.community.viewclaims[0].claimImages
            }
        },
        methods:{ 
            canDecline(){
                // alert(this.$store.state.community.viewclaims[0].status)
                if(this.$store.state.community.viewclaims[0].status==='Claims Paid'||this.$store.state.community.viewclaims[0].status==='Declined'){
                   this.snackcolor='error'
                   this.snackbarMsg="Claim cannot be declined. Claim has been paid or already declined"
                    this.snackbar = true
                }else{
                    this.dialog2=true
                }
                
            },
            canRecommend(){
                if(this.$store.state.community.viewclaims[0].status==='Claims Paid' || this.$store.state.community.viewclaims[0].status==='Recommendation Accepted'||this.$store.state.community.viewclaims[0].status=== 'Reported' || this.$store.state.community.viewclaims[0].status==='Consultant Recommended Amount' || this.$store.state.community.viewclaims[0].status==='Declined'){
                    this.snackcolor='error'
                    this.snackbarMsg = "Based on the claim status, You cannot recommend prices now."
                    this.snackbar = true
                }else{
                    this.dialog=true

                }
            },
            canMakePay(){
                if(this.$store.state.community.viewclaims[0].status!=="Recommendation Accepted" || this.$store.state.community.viewclaims[0].status==="Claim Paid"){
                    this.snackcolor='error'
                    this.snackbarMsg = "Payments cannot be made at this time, based on the status of the claim"
                    this.snackbar = true
                }else{
                    this.loadingProgress=true
                    if(this.$store.state.community.viewclaims[0].consultant_claim_amount==="" || this.$store.state.community.viewclaims[0].consultant_claim_amount===null|| this.$store.state.community.viewclaims[0].consultant_claim_amount==='0.00'){
                        this.amount= this.$store.state.community.viewclaims[0].loss_assessor_claim_amount                   
                        console.log(this.amount) 
                   }else{ 
                        this.amount =this.$store.state.community.viewclaims[0].consultant_claim_amount
                        console.log(this.amount)
                    }
                    console.log(this.amount.replace(/,/g, ''))
                    this.$store.dispatch("GeneratePaymentRef",{
                        "claimId":this.$store.state.community.viewclaims[0].id,
                        "paymentAmount":this.amount.replace(/,/g, ''),
                        "policyNumber":this.$store.state.community.viewclaims[0].policy_number,
                        "depositorsUsername":this.$store.state.community.logindetails.consultant_id,
                        "recipientUsername":this.$store.state.claims.userclaimdetails[0].username,
                        "depositorsName":this.$store.state.community.logindetails.firstname + this.$store.state.community.logindetails.lastname,
                        "recipientName":this.$store.state.claims.userclaimdetails[0].firstname + this.$store.state.claims.userclaimdetails[0].lastname,
                        "bankName":this.$store.state.claims.userclaimdetails[0].bankname,
                        "accountNumber":this.$store.state.claims.userclaimdetails[0].account_number,
                        "accountName":this.$store.state.claims.userclaimdetails[0].account_name,
                        "transactionType":"Claims",
                        "communityCode":this.$store.state.claims.userclaimdetails[0].community_code,
                        "policyHolder":this.$store.state.community.viewclaims[0].policy_holder, 
                        "paymentMethod":"Astra Pay",
                        "policyHolderContact":this.$store.state.claims.userclaimdetails[0].phonenumber,
                        "bankCode":this.$store.state.claims.userclaimdetails[0].bank_code
                    })
                    .then((success)=>{
                        console.log(success)
                        this.refNum = success.transactionReferenceNumber
                        console.log(this.refNum)
                        this.src = `https://webservices.astrapay.com.ng/astraPay.html?referenceNumber=${success.transactionReferenceNumber}`
                        this.loadingProgress=false
                        this.paydialog = true
                    })
                    .catch((err)=>{
                        this.loadingProgress=false
                        this.transFail = true
                        console.log(err)
                    })
                }
            },
            counterPay(){
                if(this.$store.state.community.viewclaims[0].status!=="Recommendation Accepted" || this.$store.state.community.viewclaims[0].status==="Claim Paid"){
                    this.snackcolor='error'
                    this.snackbarMsg = "Payments cannot be made at this time, based on the status of the claim"
                    this.snackbar = true
                }else{
                    if(this.$store.state.community.viewclaims[0].consultant_claim_amount==="" || this.$store.state.community.viewclaims[0].consultant_claim_amount===null|| this.$store.state.community.viewclaims[0].consultant_claim_amount==='0.00'){
                        this.amount= this.$store.state.community.viewclaims[0].loss_assessor_claim_amount                   
                        console.log(this.amount)
                   }else{ 
                        this.amount =this.$store.state.community.viewclaims[0].consultant_claim_amount
                        console.log(this.amount)

                    }
                    this.counterPaydialog = true
                }
            },
            haveMadeThisPayment(){
                this.$store.dispatch("GeneratePaymentRef",{
                    "claimId":this.$store.state.community.viewclaims[0].id,
                    "paymentAmount":this.amount,
                    "policyNumber":this.$store.state.community.viewclaims[0].policy_number,
                    "depositorsUsername":this.$store.state.community.logindetails.consultant_id,
                    "recipientUsername":this.$store.state.claims.userclaimdetails[0].username,
                    "depositorsName":this.$store.state.community.logindetails.firstname + this.$store.state.community.logindetails.lastname,
                    "recipientName":this.$store.state.claims.userclaimdetails[0].firstname + this.$store.state.claims.userclaimdetails[0].lastname,
                    "bankName":this.$store.state.claims.userclaimdetails[0].bankname,
                    "accountNumber":this.$store.state.claims.userclaimdetails[0].account_number,
                    "accountName":this.$store.state.claims.userclaimdetails[0].account_name,
                    "transactionType":"Claims",
                    "communityCode":this.$store.state.claims.userclaimdetails[0].community_code,
                    "policyHolder":this.$store.state.community.viewclaims[0].policy_holder, 
                    "paymentMethod":"Over the Counter",
                    "policyHolderContact":this.$store.state.claims.userclaimdetails[0].phonenumber,
                    "bankCode":this.$store.state.claims.userclaimdetails[0].bank_code
                })
                .then((success)=>{
                    this.refNum = success.transactionRefNum
                    console.log(success)
                    this.transactionCounterId=success.transactionId
                    // this.counterPaydialog = true
                    this.stepper = 2
                })
                .catch((err)=>{
                    console.log(err)
                    alert('An Error Occured Please Try Again Later')
                    this.counterPaydialog = false
                })
            },
            recommend(){
                if (this.price!==""){
                    this.loading = true
                    console.log(this.price)
                    console.log(this.$store.state.community.viewclaims[0].id)
                    console.log(this.$store.state.community.logindetails.consultant_id)
                    this.$store.dispatch("updateClaim",{
                        status:"Consultant Recommended Amount",
                        consultantAmount:this.price,
                        claimId:this.$store.state.community.viewclaims[0].id,
                        consultantUsername:this.$store.state.community.logindetails.consultant_id
                    })
                     .then((success)=>{
                        console.log(success);
                        let id = this.$store.state.community.viewclaims[0].id
                        this.$store.dispatch("ViewClaim", id)
                        this.loading = false
                        this.dialog = false
                        this.snackbarMsg = "Consultant Price Recommended Successfully"
                        this.snackbar = true
                    })
                    .catch((error)=>{
                        console.log(error);
                        this.loading = false
                        this.dialog = false
                        this.snackcolor='error'
                        this.snackbarMsg = "Consultant Recommended price unsuccessful"
                        this.snackbar= true
                    });
                }else{
                   this.snackbarMsg = "Price cannot be empty"
                   this.snackbar = true
                }
            },
            decline(){
                this.loading= true
                console.log(this.price)
                console.log(this.$store.state.community.viewclaims[0].id)
                console.log(this.$store.state.community.logindetails.consultant_id)
                this.$store.dispatch("updateClaim",{
                    status:"Declined",
                    claimId:this.$store.state.community.viewclaims[0].id,
                    consultantUsername:this.$store.state.community.logindetails.consultant_id
                })
                .then((success)=>{
                    console.log('success');
                    let id = this.$store.state.community.viewclaims[0].id
                    this.$store.dispatch("ViewClaim", id)
                    this.loading = false
                    this.dialog2 = false
                    this.snackbarMsg = "Claim Declined successfully"
                    this.snackbar = true
                    
                })
                .catch((error)=>{
                    console.log(error);
                    this.loading = false
                    this.dialog2 = false
                    this.snackcolor='error'
                    this.snackbarMsg = "Claim not declined"
                    this.snackbar = true
                });
            },
            getPolicy(id){
                this.$router.push('/community/members/viewPolicy/' +id)
            },
            getImgUrl(pic) {
                console.log(pic)
                let weblink = this.url;
                return weblink+pic;
            },
            zoom(url){
                let imgUrl=url
                 this.src = this.url +imgUrl
                this.dialog1=true
            },
            save(){
                this.dialog=false
            },
            close(){
                this.dialog=false
            },
            makePay(){
               this.$store.dispatch("ViewClaim", this.$store.state.community.viewclaims[0].id)
               .then((success)=>{
                    console.log(success)
                })
                .catch((error)=>{
                    console.log(error)
                })
                this.$store.dispatch("makePayment",this.$store.state.community.viewclaims[0].policy_holder)
                .then((success)=>{
                    console.log(success)
                     this.$router.push('/claims/makepayment/'+this.$store.state.community.viewclaims[0].policy_holder)
                })
                .catch((error)=>{
                    console.log(error)
                })
            },
            downloadWithAxios(url){
                axios({
                    method: 'get',
                    url: url,
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    
                    this.forceFileDownload(response)
                    
                })
                .catch(() => console.log('error occured'))
            },
            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'file.pdf') //or any other extension
                document.body.appendChild(link)
                link.click()
            },
            // =====CONTINUE TRANSACTION FOR OVER THE COUNTER TRANSACTIONS====
            payMethodChanged(event){
            this.paymentMethod = event
            },
            continueOverTheCounterTrans(){
                if (this.$refs.form.validate()){
                    this.loadingConfirm= true
                    this.$store.dispatch("continueOverTheCounterTrans", {transactionId:this.transactionCounterId, username:this.$store.state.community.logindetails.consultant_id, transRefNum:this.transRef, paymentMethod:this.paymentMethod})
                    .then((success)=>{
                        console.log(success);
                        this.loadingConfirm=false
                        this.counterPaydialog = false
                        this.snackbarContinueTransSuccess= true
                        this.transactionCounterId=""
                        this.transRef=""
                        this.paymentMethod=""
                        this.stepper=1

                    })
                    .catch((error)=>{
                        console.log(error);
                        this.loadingConfirm=false
                        this.counterPaydialog = false
                        this.snackbarContinueTransError= true
                        this.transactionCounterId=""
                        this.transRef=""
                        this.paymentMethod=""
                        this.stepper=1
                    });
                }      
            },
            counterPayDialogFalse(){
                this.counterPaydialog = false
                this.transactionCounterId=""
                this.transRef=""
                this.paymentMethod=""
                this.stepper=1
            }
           
        },
        created(){
            this.$store.dispatch("makePayment",this.$store.state.community.viewclaims[0].policy_holder)
            .then((success)=>{
                console.log(success)
            })
            .catch((error)=>{
                console.log(error)
            })
            this.center= { lat: Number(this.$store.state.community.viewclaims[0].incident_location_latitude), lng: Number(this.$store.state.community.viewclaims[0].incident_location_longitude) }

            //     this.name = this.$store.state.community.viewclaims[0].name
            //      this.clientId = this.$store.state.community.viewclaims[0].policy_holder
            //      this.policyNumber = this.$store.state.community.viewclaims[0].policy_number
            //      this.ownerAmount = this.$store.state.community.viewclaims[0].policy_holder_claim_amount
            //      this.claimStatus = this.$store.state.community.viewclaims[0].status
            //      this.consultAmount = this.$store.state.community.viewclaims[0].consultant_claim_amount
            //      if (this.consultAmount==="" || this.consultAmount===null){
            //          this.consultAmount='0.00'
            //      }
            //      this.assessorAmount = this.$store.state.community.viewclaims[0].loss_assessor_claim_amount
            //      if (this.assessorAmount===""||this.assessorAmount===null){
            //          this.assessorAmount='0.00'
            //      }
            //      this.cause = this.$store.state.community.viewclaims[0].incident_cause
            //      this.company = this.$store.state.community.viewclaims[0].community_name
            //      this.report = this.$store.state.community.viewclaims[0].incident_report
            //     if (this.report==="" || this.report===null){
            //          this.report='None'
            //     }
            //     this.message = this.$store.state.community.viewclaims[0].rejection_message
            //     if (this.message==="" || this.message===null){
            //         this.message='None'
            //     }

        }
    }
</script>
<style  scoped>
.v-list .v-list-item--active{
  background-color: rgb(235, 243, 231);
  cursor:pointer;
}

.loading-overlay {      
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    /* background: rgba(255, 255, 255, 0.9); */
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>